import React, {lazy, Suspense} from 'react'

const ExaminationPageLazy = lazy(() =>
    import('./ExaminationPage')
)

const ExaminationPage = props => (
    <Suspense fallback={null}>
        <ExaminationPageLazy {...props} />
    </Suspense>
)

export default ExaminationPage
